<template>
  <div>
    <button
      class="button button--1"
      @click="openFullscreenModal"
    >
      Complete profile ...
    </button>
    <complete-profile-overlay />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import CompleteProfileOverlay from '@/components/profile/CompleteProfileOverlay'

export default {
  mixins: [FormMixin],
  components: {
    CompleteProfileOverlay
  },
  methods: {
    ...mapActions({
      openFullscreenModal: 'openFullscreenModal',
      loadingDone: 'app/loadingDone',
    })
  },
  created () {
    this.loadingDone()
    this.openFullscreenModal('completeProfile')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/CompleteProfilePage.vue